<template>
    <div class="company__item">
        <div class="name">
            <p class="med p-black"><b>{{companyItem.title}}</b></p>
        </div>
        <div class="company__logo">
            <router-link :to="{name: 'companyPage', params: { id: companyItem.id }}">
                <img :src='companyItem.img' :alt='companyItem.title'>
            </router-link>
        </div>
        <div class="company__link">
            <router-link :to="{name: 'companyPage', params: { id: companyItem.id }}">
                Read more about {{companyItem.title}}
            </router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CompanyItem",
        props: {
            companyItem: Object
        }
    }
</script>
